import React, { useEffect, useState } from "react";
import SettlementHeader from "./components/SettlementHeader";
import { getAllUsers, getRollingReserveSettlement } from "../../config/LiveApi";
import SettlementTable from "./components/SettlementTable";
import { get } from "../../config/axios";
import Spinner from "../Spin/Spinner";
import { useSelector } from "react-redux";
import RRMerchantInfo from "./components/RRMerchantInfo";

function Index() {
  const token = useSelector((store) => store.userReducer.token);
  const role = useSelector((store) => store.userReducer.role);
  const [dataItem, setDataItem] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const getRollingReserveSettlements = async (
    token,
    isoDateString,
    isoEndDateString
  ) => {
    setLoading(true);
    try {
      const data = await getRollingReserveSettlement(
        token,
        isoDateString,
        isoEndDateString
      );
      setDataItem(data || []);
    } catch (error) {
      console.error("Error fetching rolling reserve settlements:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchUsers = async () => {
    try {
      const response = await getAllUsers(token, 1);
      const data = response?.data || []; // Fallback to an empty array
      setUserData(data);
    } catch (error) {
      console.error("Error fetching users:", error.message);
    }
  };

  useEffect(() => {
    const currentDate1 = new Date();
    const isoDateString1 = currentDate1.toISOString();
    const currentDate = new Date();

    currentDate.setDate(currentDate.getDate() - 1);

    const isoDateString = currentDate.toISOString();

    setStartDate(isoDateString1);
    if (role === "super" || role === "operation") fetchUsers();

    getRollingReserveSettlements(token, isoDateString, isoDateString);
  }, []);

  return (
    <div>
      <SettlementHeader
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        startDate={startDate}
        endDate={endDate}
        getRollingReserveSettlements={getRollingReserveSettlements}
      />
      <div className="mar-top-rol">
        {loading ? (
          <Spinner />
        ) : role === "super" || role === "operation" ? (
          dataItem && dataItem.length > 0 ? (
            <SettlementTable dataItem={dataItem} userData={userData} />
          ) : null
        ) : (
          
          <RRMerchantInfo dataItem={dataItem} />
        )}
      </div>
    </div>
  );
}

export default Index;